import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Headset, Mail, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function ContactTab() {
  return (
    <div className="max-w-2xl" data-testid="contact-tab">
      <h2 className="font-display text-xl font-semibold mb-1 flex items-center gap-2"><Headset className="h-5 w-5 text-indigo-600" /> Contact Us</h2>
      <p className="text-sm text-slate-500 mb-5">Need help? Reach the PGRentReceipts support team.</p>

      <Card className="p-6 border-slate-200 space-y-4">
        <Row icon={<Mail className="h-4 w-4" />} label="Email" value="pgrentreceipts.support@gmail.com" href="mailto:pgrentreceipts.support@gmail.com" testid="contact-email" />
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-md bg-[#25D366] flex items-center justify-center text-white"><MessageCircle className="h-4 w-4" /></div>
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">WhatsApp</p>
              <p className="text-sm font-medium">Chat with support</p>
            </div>
          </div>
          <Button
            className="bg-[#25D366] hover:bg-[#1ebd59] text-white"
            onClick={() => window.open("https://wa.me/919642092934", "_blank", "noopener,noreferrer")}
            data-testid="contact-whatsapp-button"
          >
            Open chat
          </Button>
        </div>
        <p className="text-xs text-slate-400 pt-2 border-t border-slate-100">Support hours: Mon–Sat, 9 AM – 7 PM IST</p>
      </Card>
    </div>
  );
}

function Row({ icon, label, value, href, testid }) {
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); toast.success("Email copied"); }
    catch { toast.error("Could not copy. Please copy it manually."); }
  };
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded-md bg-indigo-600 flex items-center justify-center text-white">{icon}</div>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</p>
          <p className="text-sm font-medium">{value}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button asChild variant="outline" size="sm" data-testid={testid}><a href={href}>Open</a></Button>
        <Button asChild variant="outline" size="sm" data-testid="contact-email-gmail">
          <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${value}`} target="_blank" rel="noopener noreferrer">Gmail</a>
        </Button>
        <Button variant="outline" size="sm" onClick={copy} data-testid="contact-email-copy">Copy</Button>
      </div>
    </div>
  );
}
